import { useEffect } from "react"
import { IPrimitiveProps } from "src/modules/pe-landing-module/views/landing/section/Primitive"
import { TEST_CURRENT_MODE } from "../../data/interfaces"
import { useTestsStore } from "../../data/store"
import SingleTest from "../single/SingleTest"

/* Protopia Ecosystem component */ 
const TestPrimitive = (props: IPrimitiveProps): JSX.Element => {
    const primitive: any = props.primitive as any  
    useEffect(() => {
        useTestsStore.setState({
            currentTest: primitive.test, 
            currentStep: 0,
            results : [],
            waybill : [
                "", 
                ...primitive.test.questions.map(q => `question/${q.id.toString()}`), 
                "finish", 
            ]
        }) 
    }, [])
    return <SingleTest 
        item={ primitive.test } 
        mode={TEST_CURRENT_MODE.START}
        titleStyle={primitive.titleStyle}
    />
}
export default TestPrimitive